import Global from './Global';

/** API 베이스 URL·호출 주소 (Android Logcat 필터: ApiUrl) */
export const logApiUrl = (step, extra = {}) => {
  const line = JSON.stringify({ baseUrl: Global.base.useUrl, ...extra });
  // console.info(`[ApiUrl] ${step} ${line}`);
};
